
// just return all state
export const getAllstate = state => state;
export const getTouchScreen = state => state.TouchScreen;
export const getTimer = state => state.CountTime;
